import { render, staticRenderFns } from "./ToggleDocumentView.vue?vue&type=template&id=6c565ae3&"
import script from "./ToggleDocumentView.vue?vue&type=script&lang=ts&"
export * from "./ToggleDocumentView.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleDocumentView.vue?vue&type=style&index=0&id=6c565ae3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VIcon,VTooltip})
